import { render } from "./ViewBotNav.vue?vue&type=template&id=50c13225"
import script from "./ViewBotNav.vue?vue&type=script&lang=js"
export * from "./ViewBotNav.vue?vue&type=script&lang=js"

import "./ViewBotNav.vue?vue&type=style&index=0&id=50c13225&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/sheratonhbjd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__